import {
  ReactElement,
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardedRef
} from 'react';
import styled, { css } from 'styled-components';

const buttonTypeColors = {
  primary: {
    color: 'var(--color-mono-100)',
    bgColor: 'var(--color-blue-40)',
    border: 'var(--color-blue-40)',
    bgColorHover: 'var(--color-blue-20)',
    borderHover: 'var(--color-blue-20)'
  },
  secondary: {
    color: 'var(--color-mono-0)',
    bgColor: 'var(--color-mono-100)',
    border: 'var(--color-mono-60)',
    bgColorHover: 'var(--color-mono-95)',
    borderHover: 'var(--color-mono-0)'
  },
  error: {
    color: 'var(--color-red-50)',
    bgColor: 'var(--color-mono-100)',
    border: 'var(--color-red-50)',
    bgColorHover: 'var(--color-mono-95)',
    borderHover: 'var(--color-red-50)'
  }
};

const StyledButton = styled.button<IButton>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 1.25rem;
  &:hover {
    cursor: pointer;
  }
  ${({ color }) => css`
    color: ${buttonTypeColors[color].color};
    background-color: ${buttonTypeColors[color].bgColor};
    border: 1px solid ${buttonTypeColors[color].border};
    &:hover,
    &:focus {
      background-color: ${buttonTypeColors[color].bgColorHover};
      border: 1px solid ${buttonTypeColors[color].borderHover};
    }
  `}
  ${({ color }) =>
    color === 'primary' &&
    css`
      &:disabled {
        background-color: var(--color-mono-60);
        border: 1px solid var(--color-mono-60);
      }
    `}
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  svg {
    font-size: var(--fontSizes-m);
  }
`;

export interface IButton extends ComponentPropsWithoutRef<'button'> {
  iconBefore?: ReactElement | null;
  iconAfter?: ReactElement | null;
  color: 'primary' | 'secondary' | 'error';
}

const Button = (props: IButton, ref: ForwardedRef<HTMLButtonElement>) => {
  const { color, children, iconBefore, iconAfter, className, ...rest } = props;

  return (
    <StyledButton color={color} className={className} ref={ref} {...rest}>
      {iconBefore}
      {children}
      {iconAfter}
    </StyledButton>
  );
};
export default forwardRef(Button);
